import { ExpandMore } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import React, { useRef, useState } from "react";
import { introductions, lessonGroups } from "../../../assets/data/data";
import {
  RootBox,
  SidebarTitle,
  ScrollableBox,
  PartTitle,
  IntroductionLink,
  LessonTitleLink,
  StyledAccordion,
  StyledAccordionSummary,
  StyledAccordionDetails,
  LessonItemBox,
  LessonNumberText,
  LessonHeadingText,
} from "./LessonSidebar.styles";

const LessonSidebar = ({ lessonsData, setLessonContent }) => {
  const [lessonState, setLessonState] = useState("");
  const [expanded, setExpanded] = useState(false);
  const sidebarRef = useRef(null);

  const handleAccordionChange = (panelId, lessonIndex, partIndex) => (event, isExpanded) => {
    setExpanded(isExpanded ? panelId : false);

    if (isExpanded && sidebarRef.current) {
      requestAnimationFrame(() => {
        sidebarRef.current.scrollTo({
          top: (partIndex * 12 + lessonIndex) * 50,
          behavior: "smooth",
        });
      });
    }
  };

  const handleIntroductionClick = (partIndex) => () => {
    setLessonContent(introductions[partIndex]?.content);
  };

  const handleLessonItemClick = (lessonNumber, content) => () => {
    setLessonState(lessonNumber);
    setLessonContent(content);
  };

  return (
    <RootBox>
      <SidebarTitle>All Lessons</SidebarTitle>

      <ScrollableBox ref={sidebarRef}>
        {lessonGroups.map((part, partIndex) => (
          <Box key={part.part}>
            <PartTitle>{part.part}</PartTitle>

            <IntroductionLink onClick={handleIntroductionClick(partIndex)}>
              Introduction
            </IntroductionLink>

            {part.lessons.map((lesson, lessonIndex) => {
              const panelId = `panel-${partIndex}-${lessonIndex}`;
              const groupLessons = lessonsData?.filter(
                (val) => val?.groupId === lesson.id
              );

              if (lesson.content) {
                return (
                  <LessonTitleLink key={panelId}>
                    {lesson.title}
                  </LessonTitleLink>
                );
              }

              return (
                <StyledAccordion
                  key={panelId}
                  disableGutters
                  expanded={expanded === panelId}
                  onChange={handleAccordionChange(panelId, lessonIndex, partIndex)}
                  $expanded={expanded === panelId}
                  $isFirst={lessonIndex === 0}
                >
                  <StyledAccordionSummary expandIcon={<ExpandMore />}>
                    <Typography>{lesson.title}</Typography>
                  </StyledAccordionSummary>
                  <StyledAccordionDetails>
                    {groupLessons?.map((lessonItem, index) => {
                      const isLast =
                        index === (groupLessons?.length ?? 0) - 1;
                      return (
                        <LessonItemBox
                          key={lessonItem?.lessonNumber ?? index}
                          $active={lessonState === lessonItem?.lessonNumber}
                          $isLast={isLast}
                          onClick={handleLessonItemClick(
                            lessonItem?.lessonNumber,
                            lessonItem?.content
                          )}
                        >
                          <LessonNumberText>
                            Lesson {lessonItem?.lessonNumber}
                          </LessonNumberText>
                          <LessonHeadingText component="span">
                            {lessonItem?.heading}
                          </LessonHeadingText>
                        </LessonItemBox>
                      );
                    })}
                  </StyledAccordionDetails>
                </StyledAccordion>
              );
            })}
          </Box>
        ))}
      </ScrollableBox>
    </RootBox>
  );
};

export default LessonSidebar;
